import React, {useEffect, useState} from 'react';
import '/site/parts/breadcrumbs/breadcrumbs.scss'
import {IBreadcrumb} from "/react4xp/parts/breadcrumbs/breadcrumbs.type";
import {localize} from "mixins/helpers";
import { Typography } from 'antd';

const Breadcrumbs = (props) => {
    const [items, setItems] = useState<IBreadcrumb[]>();

    const findParentPages = (parent: any, arr) => {
        if (parent.parent && parent.type !== 'base:folder') {
            arr.unshift({
                name: parent.displayName,
                url: parent._path && parent._path.replace('/isna-portal-cms',''),
            });
            return findParentPages(parent.parent, arr);
        }

        if (props.parent) {
            arr.unshift({
                name: props.parent.displayName,
                url: props.parent._path && props.parent._path.replace('/isna-portal-cms',''),
            })
        }

        arr.unshift({
            name: localize('main-page', props.translations),
            url: '/',
        });

        return arr;
    };

    function removeDuplicateObjects(arr) {
        const uniqueArray = arr.filter(function(item, index, self) {
            return index === self.findIndex((t) => (
                t.id === item.id && t.name === item.name
            ));
        });
        return uniqueArray;
    }

    useEffect(() => {
        if (props.translations) {
            if (props.guillotineResult) {
                const result = JSON.parse(props.guillotineResult);

                if (result && result.data && result.data.guillotine && result.data.guillotine.get) {
                    const page = result.data.guillotine.get;
                    const arr = removeDuplicateObjects(findParentPages(page, []));
                    setItems(arr);
                }
            }
        }
    }, [props.translations]);

    return (
        <Typography.Text>
            <div className="breadcrumb">
                {items && items.map((x, id )=> x.url ? (
                        <div key={id + x.url} className="breadcrumb__item">
                            <a href={`/${props.language}${x.url}`}>{x.name}</a>
                        </div>
                    ) : (
                        <div key={id + x.name} className="breadcrumb__item">{x.name}</div>
                    ))
                }
            </div>
        </Typography.Text>
    );
};

export default Breadcrumbs;
